import styled from 'styled-components'
import {backgroundColor, white, dangerBackground, mediumGray} from '@modifi/colors'
import {ModifiUiApp} from '@modifi/ui'

export const DetailsTable = styled.table`
  margin-bottom: 20px;
  width: 100%;
  border-spacing: 0;
`

export const DetailsTh = styled.th`
  text-align: ${({align}) => align || 'left'};
  padding: 35px 0 8px;
`

export const DetailsThead = styled.thead`
  background: ${({inverseBackground}) => (inverseBackground ? white : backgroundColor)};
  ${({isSticky}) =>
    isSticky
      ? `
    position: sticky;
    top: 0px;
  `
      : ''}
`

export const DetailsTd = styled.td`
  font-size: 12px;
  padding: 20px 15px;
  max-width: 240px;

  strong {
    display: block;
    margin-bottom: 10px;
    white-space: nowrap;
  }

  p {
    margin: 0;
  }
`

export const DetailsTdCentered = styled(DetailsTd)`
  vertical-align: middle;
`

export const DetailsTrow = styled.tr`
  ${DetailsTdCentered} {
    background: ${({hasError}) => (hasError ? dangerBackground : 'transparent')};
  }
`

export const DetailsTbody = styled.tbody`
  background: ${({inverseBackground}) => (inverseBackground ? backgroundColor : white)};
  vertical-align: top;
  ${({isSticky}) =>
    isSticky
      ? `
    position: sticky;
    top: 60px;
    > tr {
      outline: ${mediumGray} solid 2px;
    }
  `
      : ''}
`

export const ModifiUiAppSized = styled(ModifiUiApp)`
  min-height: 100vh;
  min-width: fit-content;
`
